import { useRef, useState } from 'react';
import { IonModal, IonButton, IonIcon, IonImg, IonGrid, IonRow, IonCol, IonLabel, IonInput, useIonToast } from '@ionic/react';
import { close, eyeOffOutline, eyeOutline } from 'ionicons/icons';
import { ValidateEqualTo } from '../../../defines/Functions';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { TogglePassword } from '../../../defines/Functions';
import axios from "axios";
import Loading from '../../Loading';
import './ProfilePassword.css';
import profilePassword from '../../../assets/images/dashboard-profile-password.svg';

const ProfilePassword = () => {
    const profilePasswordApi = Constants.api.profilePassword;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    };
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfilePasswordModal: false,
        token: ''
    });
    const [formData, setFormData] = useState({
        oldpassword: '',
        newpassword: '',
        newpassword_c: ''
    });
    const [required, setRequired] = useState({
        oldpassword: { value: false, message: '' },
        newpassword: { value: false, message: '' },
        newpassword_c: { value: false, message: '' }
    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        let isPasswordEmpty = false;
        if (formData.oldpassword.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, oldpassword: { value: true, message: 'الزامی' } } });
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, oldpassword: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (formData.newpassword.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: true, message: 'الزامی' } } });
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (formData.newpassword_c.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, newpassword_c: { value: true, message: 'الزامی' } } });
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, newpassword_c: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (!isPasswordEmpty) {
            if (!ValidateEqualTo(formData.newpassword, formData.newpassword_c)) {
                setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: true, message: '' }, newpassword_c: { value: true, message: 'رمز عبور مطابقت ندارد' } } });
            }
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        let isPasswordEmpty = false;
        if (formData.oldpassword.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, oldpassword: { value: true, message: 'الزامی' } } });
            isRequired = true;
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, oldpassword: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (formData.newpassword.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: true, message: 'الزامی' } } });
            isRequired = true;
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (formData.newpassword_c.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, newpassword_c: { value: true, message: 'الزامی' } } });
            isRequired = true;
            isPasswordEmpty = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, newpassword_c: { value: false, message: '' } } });
            isPasswordEmpty = false;
        }
        if (!isPasswordEmpty) {
            if (!ValidateEqualTo(formData.newpassword, formData.newpassword_c)) {
                setRequired(prevRequired => { return { ...prevRequired, newpassword: { value: true, message: '' }, newpassword_c: { value: true, message: 'رمز عبور مطابقت ندارد' } } });
                isRequired = true;
            }
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        let submitFormData = new FormData();
        submitFormData.append("oldpassword", formData.oldpassword);
        submitFormData.append("newpassword", formData.newpassword);
        try {
            const formResults = await axios.post(profilePasswordApi, submitFormData, {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.result === 'error') {
                showToast({ message: formResults.data.message, color: 'danger' });
                setFormData({
                    oldpassword: '',
                    newpassword: '',
                    newpassword_c: ''
                });
                setLoading(false);
            } else {
                setFormData({
                    oldpassword: '',
                    newpassword: '',
                    newpassword_c: ''
                });
                showToast({ message: formResults.data.message, color: 'success' });
                setState({ ...state, showProfilePasswordModal: false });
                setLoading(false);
            }
        } catch (error) {
            // console.log(error);
            setLoading(false);
        }
    }
    return (
        <>
            <IonModal isOpen={state.showProfilePasswordModal} onDidDismiss={() => setState({ ...state, showProfilePasswordModal: false })} mode="ios" cssClass="profile-password-modal">
                <div className="profile-password-modal-content">
                    <h3 className="profile-password-modal-title">
                        تغییر رمز عبور
                        <IonIcon icon={close} onClick={() => setState({ ...state, showProfilePasswordModal: false })} />
                    </h3>
                    <div className="profile-password-modal-input-container">
                        <form onSubmit={handleSubmit}>
                            {!loading ?
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size="12">
                                            <IonLabel>
                                                رمز عبور فعلی
                                                {required.oldpassword.value ? <span className="required">{required.oldpassword.message}</span> : null}
                                            </IonLabel>
                                            <IonInput
                                                type="password"
                                                id="oldPasswordPass"
                                                name="oldpassword"
                                                value={formData.oldpassword || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                            />
                                            <IonIcon
                                                icon={eyeOutline}
                                                id="oldPasswordPassIcon"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("oldPasswordPass", "oldPasswordText", "oldPasswordPassIcon", "oldPasswordTextIcon") }}
                                            />
                                            <IonInput
                                                type="text"
                                                id="oldPasswordText"
                                                name="oldpassword"
                                                value={formData.oldpassword || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                                style={{ display: 'none' }}
                                            />
                                            <IonIcon
                                                icon={eyeOffOutline}
                                                id="oldPasswordTextIcon"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("oldPasswordPass", "oldPasswordText", "oldPasswordPassIcon", "oldPasswordTextIcon") }}
                                                style={{ display: 'none' }}
                                            />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                رمز عبور جدید
                                                {required.newpassword.value ? <span className="required">{required.newpassword.message}</span> : null}
                                            </IonLabel>
                                            <IonInput
                                                type="password"
                                                id="newPasswordPass"
                                                name="newpassword"
                                                value={formData.newpassword || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                            />
                                            <IonIcon
                                                icon={eyeOutline}
                                                id="newPasswordPassIcon"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("newPasswordPass", "newPasswordText", "newPasswordPassIcon", "newPasswordTextIcon") }}
                                            />
                                            <IonInput
                                                type="text"
                                                id="newPasswordText"
                                                name="newpassword"
                                                value={formData.newpassword || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                                style={{ display: 'none' }}
                                            />
                                            <IonIcon
                                                icon={eyeOffOutline}
                                                id="newPasswordTextIcon"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("newPasswordPass", "newPasswordText", "newPasswordPassIcon", "newPasswordTextIcon") }}
                                                style={{ display: 'none' }}
                                            />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                تکرار رمز عبور جدید
                                                {required.newpassword_c.value ? <span className="required">{required.newpassword_c.message}</span> : null}
                                            </IonLabel>
                                            <IonInput
                                                type="password"
                                                id="newPasswordPassC"
                                                name="newpassword_c"
                                                value={formData.newpassword_c || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                            />
                                            <IonIcon
                                                icon={eyeOutline}
                                                id="newPasswordPassIconC"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("newPasswordPassC", "newPasswordTextC", "newPasswordPassIconC", "newPasswordTextIconC") }}
                                            />
                                            <IonInput
                                                type="text"
                                                id="newPasswordTextC"
                                                name="newpassword_c"
                                                value={formData.newpassword_c || ""}
                                                onIonChange={e => handleChange(e)}
                                                onIonBlur={handleBlur}
                                                style={{ display: 'none' }}
                                            />
                                            <IonIcon
                                                icon={eyeOffOutline}
                                                id="newPasswordTextIconC"
                                                className="toggle-password"
                                                onClick={() => { TogglePassword("newPasswordPassC", "newPasswordTextC", "newPasswordPassIconC", "newPasswordTextIconC") }}
                                                style={{ display: 'none' }}
                                            />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonButton type="submit" color="warning" expand="block">تغییر رمز عبور</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                                :
                                <Loading />
                            }
                        </form>
                    </div>
                </div>
            </IonModal>
            <div className="dashboard-box" onClick={() => setState({ ...state, showProfilePasswordModal: true })}>
                <div>
                    <IonImg src={profilePassword} />
                </div>
                <div>
                    <b>تغییر رمز عبور</b>
                </div>
            </div>
        </>
    );
};
export default ProfilePassword;